import { useEffect, useRef } from "react"
import { useScroll, AnimatePresence, motion } from "framer-motion"
import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import generateComponents, { parseModularBlock } from "utils/generateComponents"

import ScrollInvit from "components/scroll-invit/ScrollInvit"

import { StateProvider, useValue } from "./context"
import Pagination from "./Pagination"

import AshlarReturnVisitor from "./return-visitor/AshlarReturnVisitor"

const Root = styled.section`
  position: relative;
  background: #212121;
`

const PaginationContainer = styled(motion.div)`
  position: absolute;
  height: 100%;
  width: fit-content;
  top: 0;
  z-index: 10;
  pointer-events: none;
  transform: translateX(-50%);
  inset-inline-end: calc(var(--outer-margin) / 2);
`

function WallContent({ scrollinvit, pagination_hide, children }) {
  const console = useConsole()
  const { currentIndex, targetSlide, input, _input, prog, y, pagesCount, returning_pos } = useValue()

  const ref = useRef()
  const listRef = useRef()

  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] })

  function onYp(y) {
    prog.set(y)
    currentIndex.set(_input.get().findLastIndex(item => item <= y))
  }
  useEffect(() => scrollYProgress.onChange(onYp))

  function onTargetChange(i) {
    if (i === -1) return
    if (i === 0) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    } else {
      const el = document.getElementById(`ashlar--${i}`)
      el?.scrollIntoView({ behavior: "smooth", block: el.getAttribute("data-scroll-pos"), inline: "nearest" })
    }
  }
  useEffect(() => targetSlide.onChange(onTargetChange))

  return (
    <Root ref={ref} style={{ "--returning-pos": returning_pos }}>
      <AnimatePresence>
        {!pagination_hide && pagesCount > 1 ? (
          <PaginationContainer
            key='pagination'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ type: "tween", duration: 0.7 }}
          >
            <Pagination pagesCount={pagesCount} />
          </PaginationContainer>
        ) : null}
      </AnimatePresence>
      <ul ref={listRef}>{children}</ul>
      {scrollinvit ? <ScrollInvit /> : null}
    </Root>
  )
}

export default function AshlarWall({ scrollinvit, pagination_hide, returning_visitor_hide, ashlars, event_card, returning_pos }) {
  const console = useConsole()

  const modular = parseModularBlock(ashlars, { console }).map((item, i) => Object.assign(item, { index: i }))
  const blocks = generateComponents(modular, { console })
  if (!returning_visitor_hide) blocks.splice(returning_pos - 1, 0, <AshlarReturnVisitor key='ashlar-visitor' event_card={event_card} />)

  return (
    <StateProvider returning_pos={returning_pos}>
      <WallContent pagination_hide={pagination_hide} scrollinvit={scrollinvit}>
        {blocks}
      </WallContent>
    </StateProvider>
  )
}
